import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const config = defineConfig({
  theme: {
    tokens: {
      fonts: {
        heading: {
          value:
            "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
        },
        body: {
          value:
            "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
        },
        mono: {
          value: "'JetBrains Mono', monospace",
        },
      },
    },
  },
  globalCss: {
    'html, body': {
      bg: '#070910',
      color: '#F8FAFC',
      fontFamily:
        "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif",
      overflowX: 'hidden',
    },
    '::selection': {
      background: 'rgba(236, 72, 153, 0.35)',
      color: '#ffffff',
    },
    '::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
    },
    '::-webkit-scrollbar-track': {
      background: 'rgba(10, 12, 20, 0.8)',
    },
    '::-webkit-scrollbar-thumb': {
      background: 'rgba(148, 163, 184, 0.25)',
      borderRadius: '999px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(236, 72, 153, 0.5)',
    },
    // Sleek 2026 glass tables
    table: {
      color: 'white',
      borderCollapse: 'separate',
      borderSpacing: '0',
      width: '100%',
    },
    'thead tr': {
      bg: 'linear-gradient(90deg, rgba(124, 58, 237, 0.32) 0%, rgba(236, 72, 153, 0.28) 50%, rgba(6, 182, 212, 0.28) 100%) !important',
      backdropFilter: 'blur(12px)',
    },
    th: {
      color: '#E2E8F0 !important',
      borderColor: 'rgba(255, 255, 255, 0.1) !important',
      bg: 'transparent !important',
      fontWeight: '700',
      textTransform: 'uppercase',
      letterSpacing: '0.08em',
      fontSize: '0.75rem',
      py: '14px !important',
      px: '16px !important',
    },
    td: {
      color: '#F1F5F9 !important',
      borderColor: 'rgba(255, 255, 255, 0.06) !important',
      py: '12px !important',
      px: '16px !important',
      fontSize: '0.92rem',
    },
    'tbody tr': {
      bg: 'rgba(15, 23, 42, 0.45) !important',
      color: 'white !important',
      transition: 'all 0.2s cubic-bezier(0.16, 1, 0.3, 1)',
    },
    'tbody tr:nth-of-type(odd)': {
      bg: 'rgba(30, 27, 75, 0.32) !important',
    },
    'tbody tr:hover': {
      bg: 'rgba(236, 72, 153, 0.18) !important',
    },
    'tbody tr td': {
      bg: 'transparent !important',
    },
    // Dark glass react-datepicker overrides
    '.react-datepicker-popper': {
      zIndex: '9999 !important',
    },
    '.react-datepicker': {
      backgroundColor: '#0F1424 !important',
      border: '1px solid rgba(255, 255, 255, 0.14) !important',
      borderRadius: '16px !important',
      color: '#F8FAFC !important',
      fontFamily: "'Plus Jakarta Sans', sans-serif !important",
      boxShadow: '0 20px 50px rgba(0, 0, 0, 0.7) !important',
      overflow: 'hidden',
    },
    '.react-datepicker__header': {
      backgroundColor: '#161D33 !important',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1) !important',
    },
    '.react-datepicker__current-month, .react-datepicker__day-name': {
      color: '#F8FAFC !important',
    },
    '.react-datepicker__day': {
      color: '#CBD5E1 !important',
      borderRadius: '8px !important',
    },
    '.react-datepicker__day:hover': {
      backgroundColor: 'rgba(236, 72, 153, 0.3) !important',
      color: '#ffffff !important',
    },
    '.react-datepicker__day--selected, .react-datepicker__day--keyboard-selected':
      {
        background: 'linear-gradient(135deg, #ec4899, #8b5cf6) !important',
        color: '#ffffff !important',
        fontWeight: 'bold',
      },
    '.react-datepicker__year-dropdown': {
      backgroundColor: '#161D33 !important',
      border: '1px solid rgba(255, 255, 255, 0.14) !important',
      color: '#F8FAFC !important',
    },
    '.react-datepicker__year-option:hover': {
      backgroundColor: 'rgba(139, 92, 246, 0.35) !important',
    },
    // Mapbox popup dark glass polish
    '.mapboxgl-popup-content': {
      background: 'rgba(15, 19, 32, 0.92) !important',
      backdropFilter: 'blur(16px)',
      border: '1px solid rgba(255, 255, 255, 0.15)',
      borderRadius: '14px !important',
      padding: '12px 16px !important',
      boxShadow: '0 16px 40px rgba(0, 0, 0, 0.6) !important',
      color: '#ffffff !important',
    },
    '.mapboxgl-popup-tip': {
      borderBottomColor: 'rgba(15, 19, 32, 0.92) !important',
      borderTopColor: 'rgba(15, 19, 32, 0.92) !important',
    },
  },
});

export const system = createSystem(defaultConfig, config);
